import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import { styled } from '@mui/material/styles';
import { colorPalette } from '../../colorPalette';
import { makeStyles } from 'tss-react/mui';
export const useStyleDropzone = makeStyles()(() => {
    return {
        root: {
            display: 'flex',
            justifyContent: 'center',
            height: '122px',
            backgroundColor: colorPalette.gray100,
            border: `1px dashed ${colorPalette.gray300}`,
            boxSizing: 'border-box',
            borderRadius: '4px',
            minHeight: 'auto',
        },
        active: {
            borderColor: colorPalette.green800,
            background: colorPalette.green100,
        },
        invalid: {
            borderColor: colorPalette.red800,
            background: colorPalette.red100,
        },
        textContainer: {
            color: colorPalette.gray800,
            display: 'flex',
            flexDirection: 'column-reverse',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '1rem',
        },
        text: {
            margin: 0,
            fontSize: '1.4rem',
            lineHeight: '1.8rem',
        },
        icon: {
            color: 'inherit',
            width: '3rem',
            height: '3rem',
            marginBottom: '1rem',
        },
    };
});
export const IconContainer = styled(IconButton)({
    position: 'absolute',
    top: 0,
    right: 0,
    padding: 6,
    color: colorPalette.white,
});
export const ImageContainer = styled(Grid)({
    position: 'relative',
});
export const gridItem = {
    height: '130px',
    flexBasis: '130px',
    flexGrow: 0,
    padding: 4,
};
export const StyledImage = styled('img')({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '4px',
});
